export function getStaticsUrl(): string {
  const _window = window as any
  const staticsRoot =
    'https://static.parastorage.com/services/cookie-consent-settings-ui/'
  let staticsUrl = ''
  if (_window.staticsBaseUrl) {
    staticsUrl = _window.staticsBaseUrl
  }
  if (
    _window.wixTagManager &&
    typeof _window.wixTagManager.getConfig === 'function'
  ) {
    staticsUrl = _window.wixTagManager.getConfig().wixBannerStatics
  }
  if (!staticsUrl) {
    const scripts = document.getElementsByTagName('script')
    Array.prototype.forEach.call(scripts, (script) => {
      if (!staticsUrl && script.src.indexOf(staticsRoot) > -1) {
        const version = script.src.split(staticsRoot)[1].split('/').shift()
        staticsUrl = `${staticsRoot}${version}/`
      }
    })
  }
  return staticsUrl
}
